import { FC } from 'react';

import { ChipSelector } from 'components/_basic/Form/ChipSelector/ChipSelector';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';

import { IFinancialPlanChipSelectorProps } from './types';

import styles from './FinancialPlanChipSelector.module.scss';

export const FinancialPlanChipSelector: FC<IFinancialPlanChipSelectorProps> = ({
  wrapWithSectionCard = true,
  ...restProps
}) => {
  const Component = <ChipSelector {...restProps} chipStyles={{ chipStyle: styles.chip, selected: styles.selected }} />;

  if (wrapWithSectionCard) return <FormSectionCard>{Component}</FormSectionCard>;
  return Component;
};
